import React from "react";
import { Box, Collapse, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
var useStyles = makeStyles(function (theme) { return ({
    close: {
        cursor: "pointer",
        height: theme.spacing(2.5),
        width: "auto",
    },
    notification: {
        alignItems: "center",
        background: "#E24763",
        borderRadius: theme.spacing(0.5),
        color: "#FFFFFF",
        display: "flex",
        justifyContent: "space-between",
        padding: theme.spacing(2, 7),
        width: "calc(100% - " + theme.spacing(14) + "px)",
        zIndex: 999999,
    },
    title: {
        color: "#FFFFFF",
        fontSize: "15px",
    },
}); });
export var Notification = function (_a) {
    var text = _a.text, setCloseErrorNotification = _a.setCloseErrorNotification, open = _a.open;
    var classes = useStyles();
    return (React.createElement(Collapse, { in: open, timeout: "auto", unmountOnExit: true },
        React.createElement(Box, { className: classes.notification },
            React.createElement(Typography, { variant: "h6", className: classes.title }, text),
            React.createElement(CloseIcon, { className: classes.close, onClick: setCloseErrorNotification }))));
};
export default Notification;
